import {isAxiosError} from 'axios';

export const EMAIL_OTP_SEND_FAILED_MESSAGE = 'Failed to send code, please try again with a different email.';

export const EMAIL_OTP_UNDELIVERABLE_MESSAGE =
  "We can't send email to this address because earlier messages to it bounced or were blocked. " +
  'Please contact your TOCA center to update your email.';

/**
 * The message to show when requesting an email verification code failed.
 *
 * The API answers `422` with `reason: 'email-undeliverable'` when our email provider refuses the address
 * (a past hard bounce, spam complaint or manual block). Resending can never succeed then, so say so.
 */
export const getSendEmailOtpErrorMessage = (error: unknown) => {
  if (isAxiosError(error) && error.response?.data?.reason === 'email-undeliverable') {
    return EMAIL_OTP_UNDELIVERABLE_MESSAGE;
  }
  return EMAIL_OTP_SEND_FAILED_MESSAGE;
};
